





























































































































































import {Component, Vue, Watch} from "vue-property-decorator";
  import {mapGetters} from "vuex";
  import Game from "@/model/Game";
  import {PlayerInfo} from "@/model/Player";
  import {EfayaModV1Weapons, EfayaV2Weapons, IMMWeapons, WeaponNames, WW2Weapons} from "@/model/Weapons";
  import { merge } from "lodash";
  import {GameService} from "@/services/GameService";

  @Component({
  computed: {
    ...mapGetters({
      games: "games"
    })
  }
})
export default class PlayerDetails extends Vue {
  public player: PlayerInfo | null = null;
  public partKeys: string[] = [];
  public weaponNamer = {
    efaya_v2: new EfayaV2Weapons(), imm: new IMMWeapons(),
    efaya_mod_test: new EfayaModV1Weapons(), ww2m: new WW2Weapons()};
  public nemesisGuid: string = "";
  public nemesisValue: string = "";
  public preyGuid: string = "";
  public preyValue: string = "";
  public archangelGuid: string = "";
  public archangelValue: string = "";
  public blackCatGuid: string = "";
  public blackCatValue: string = "";
  public wingManGuid: string = "";
  public wingManValue: string = "";
  public killsSeries: number[] = [];
  public deathsSeries: number[] = [];
  public seriesLabels: string[] = [];
  public playedGames: string[] = [];
  protected games!: Game[];

  public created() {
    this.updatePlayerData();
  }

  @Watch("games")
  public updatePlayerData() {
    let partsSum = 0;
    const nemesis: any = {};
    const prey: any = {};
    const archangel: any = {};
    const wingMan: any = {};
    const blackCat: any = {};
    this.player = null;
    this.killsSeries = [];
    this.deathsSeries = [];
    this.seriesLabels = [];
    this.playedGames = [];

    this.games.forEach((game) => {
      game.players.forEach((player) => {
        if (player.playerRef.guid === this.$route.params.guid) {
          if (!this.player) {
            this.player = new PlayerInfo(player.playerRef);
          }
          this.killsSeries.push(player.totalKills);
          this.deathsSeries.push(player.totalDeaths);
          this.seriesLabels.push(game.date.getDate() + "/" + (game.date.getMonth() + 1));
          this.playedGames.push(game.map);
          const [winnersGuid, losersGuid] = new GameService().computeWinnersLosers(game);
          game.players.forEach((_p) => {
            if (_p.playerRef.guid !== player.playerRef.guid) {
              if (winnersGuid.indexOf(player.playerRef.guid) > -1 && winnersGuid.indexOf(_p.playerRef.guid) > -1) {
                if (!wingMan[_p.playerRef.guid]) {
                  wingMan[_p.playerRef.guid] = 0;
                }
                wingMan[_p.playerRef.guid]++;
              } else if (losersGuid.indexOf(player.playerRef.guid) > -1 && losersGuid.indexOf(_p.playerRef.guid) > -1) {
                if (!blackCat[_p.playerRef.guid]) {
                  blackCat[_p.playerRef.guid] = 0;
                }
                blackCat[_p.playerRef.guid]++;
              }
            }
          });
          this.checkInfo(player.totalScore, game.map, "bestScore");
          this.checkInfo(player.totalKills, game.map, "bestKills");
          this.checkInfo(player.totalDeaths, game.map, "bestDeaths", true);
          this.checkInfo(player.totalAssists, game.map, "bestAssists");
          this.checkInfo(player.globalRatio, game.map, "bestRatio");
          this.checkInfo(player.killsConfirmed, game.map, "killsConfirmed");
          this.checkInfo(player.killsDenied, game.map, "killsDenied");
          this.checkInfo(player.bombsPlanted, game.map, "bombsPlanted");
          this.checkInfo(player.bombsDefused, game.map, "bombsDefused");
          this.checkInfo(player.headShots, game.map, "headShots");
          this.checkInfo(player.teamKills, game.map, "teamKills");
          this.checkInfo(player.grenadeKills, game.map, "grenadeKills");
          this.checkInfo(player.pistolKills, game.map, "pistolKills");
          this.checkInfo(player.smgKills, game.map, "smgKills");
          this.checkInfo(player.shotgunKills, game.map, "shotgunKills");
          this.checkInfo(player.rifleKills, game.map, "rifleKills");
          this.checkInfo(player.sniperKills, game.map, "sniperKills");
          this.checkInfo(player.meleeKills, game.map, "meleeKills");
          this.checkInfo(player.suicides, game.map, "suicides");
          this.checkInfo(player.tchatter, game.map, "tchatter");
          this.checkInfo(player.consistency, game.map, "consistency", true);
          this.checkInfo(player.consistency, game.map, "inconsistency");
          this.checkInfo(player.accuracy, game.map, "accuracy");
          this.checkInfo(player.distance, game.map, "distance");
          this.checkInfo(player.longestHS, game.map, "longestHS");
          this.checkInfo(player.longestKill, game.map, "longestKill");
          this.checkInfo(player.killstreak, game.map, "killstreak");
          this.checkInfo(player.deathstreak, game.map, "deathstreak");
          for (const [key, value] of Object.entries(player.parts)) {
            partsSum += value as number;
            if (!this.player.parts[key]) {
              this.player.parts[key] = value;
            } else {
              this.player.parts[key] += value;
            }
          }
          for (const [mod, value] of Object.entries(player.weaps)) {
            if (!this.player.weaps[mod]) {
              this.player.weaps[mod] = {};
            }
            for (const [weap, _value] of Object.entries(value as Object)) {
              if (!this.player.weaps[mod][weap]) {
                this.player.weaps[mod][weap] = _value;
              } else {
                this.player.weaps[mod][weap] += _value;
              }
            }
          }
          if (player.nemesis) {
            for (const [guid, value] of Object.entries(player.nemesis)) {
              if (!nemesis[guid]) {
                nemesis[guid] = 0;
              }
              nemesis[guid] += value;
            }
          }
          if (player.prey) {
            for (const [guid, value] of Object.entries(player.prey)) {
              if (!prey[guid]) {
                prey[guid] = 0;
              }
              prey[guid] += value;
            }
          }
          if (player.archangel) {
            for (const [guid, value] of Object.entries(player.archangel)) {
              if (!archangel[guid]) {
                archangel[guid] = 0;
              }
              archangel[guid] += value;
            }
          }
        }
      });
    });
    if (this.player) {
      this.playedGames = this.playedGames.reverse();
      this.nemesisGuid = Object.keys(nemesis).sort(function(a, b) {return nemesis[a] - nemesis[b]; }).reverse()[0];
      this.nemesisValue = nemesis[this.nemesisGuid];
      this.preyGuid = Object.keys(prey).sort(function(a, b) {return prey[a] - prey[b]; }).reverse()[0];
      this.preyValue = prey[this.preyGuid];
      this.archangelGuid = Object.keys(archangel).sort(function(a, b) {return archangel[a] - archangel[b]; }).reverse()[0];
      this.archangelValue = archangel[this.archangelGuid];
      this.blackCatGuid = Object.keys(blackCat).sort(function(a, b) {return blackCat[a] - blackCat[b]; }).reverse()[0];
      this.blackCatValue = blackCat[this.blackCatGuid];
      this.wingManGuid = Object.keys(wingMan).sort(function(a, b) {return wingMan[a] - wingMan[b]; }).reverse()[0];
      this.wingManValue = wingMan[this.wingManGuid];
      // @ts-ignore
      for (const [key, value] of Object.entries(this.player.parts)) {
        // @ts-ignore
        this.player.parts[key] = (value as number * 100) / partsSum;
      }
      // @ts-ignore
      this.partKeys = Object.keys(this.player.parts).sort((a, b) => this.player.parts[b] - this.player.parts[a]);
    }
  }

  get options() {
    return {
      title: {
        text: "Evolution kills / deaths"
      },
      chart: {
        toolbar: {
          show: false
        },
        zoom: {
          enabled: false
        }
      },
      xaxis: {
        type: "category",
        categories: this.seriesLabels.reverse()
      },
      theme: {
        mode: "dark"
      },
      tooltip: {
        custom: (data: any) => {
          return "<div style='padding: 10px'>" +
                  "<strong>" + this.seriesLabels[data.dataPointIndex] + " - " + this.playedGames[data.dataPointIndex] + "</strong>" +
                  "<div>Kills: " + data.series[0][data.dataPointIndex] + "</div>" +
                  "<div>Deaths: " + data.series[1][data.dataPointIndex] + "</div>" +
                  "</div>";
        },
      },
      stroke: {
        curve: "smooth"
      }
    };
  }
  get series() {
    return [
      {
        name: "Kills",
        data: this.killsSeries.reverse()
      },
      {
        name: "Deaths",
        data: this.deathsSeries.reverse()
      }
    ];
  }

  public giveMeMyName(ref: string): string {
    let name = "";
    this.games.forEach((g) => {
      const found = g.players.find((p) => p.playerRef.guid === ref);
      if (found) {
        name = found.playerRef.playerName;
      }
    });
    return name;
  }

  public goToPlayer(guid: string) {
    this.$router.push({ path: "/player/" + guid});
    this.updatePlayerData();
  }

  public sortByWeaponValues(array: any) {
    return Object.keys(array).sort((a, b) => {
      return array[b] - array[a];
    });
  }

  public weaponName(weapon: string, mod: string): string {
    // @ts-ignore
    if (this.weaponNamer[mod]) {
      // @ts-ignore
      return (this.weaponNamer[mod] as WeaponNames).giveMeMyHumanName(weapon);
    }
    return weapon;
  }

  public bodyPartName(part: string): string {
    switch (part) {
      case "torso_upper":
        return "Torse";
      case "torso_lower":
        return "Ventre";
      case "right_leg_upper":
        return "Cuisse droite";
      case "left_leg_upper":
        return "Cuisse gauche";
      case "right_leg_lower":
        return "Jambe droite";
      case "left_leg_lower":
        return "Jambe gauche";
      case "head":
        return "Pleine tête";
      case "helmet":
        return "Casque";
      case "right_arm_upper":
        return "Biceps droit";
      case "left_arm_upper":
        return "Biceps gauche";
      case "right_arm_lower":
        return "Avant-bras droit";
      case "left_arm_lower":
        return "Avant-bras gauche";
      case "neck":
        return "Cou";
      case "right_foot":
        return "Pied droit";
      case "left_foot":
        return "Pied gauche";
      case "left_hand":
        return "Main gauche";
      case "right_hand":
        return "Main droite";
      default:
        return part;
    }
  }

  public isEfayaMod(mod: string) {
    return mod.startsWith("efaya_mod");
  }

  public isEfayaModV2(mod: string) {
    return mod.startsWith("efaya_v2");
  }

  public isIMMMod(mod: string) {
    return mod.startsWith("imm");
  }

  public isPromod(mod: string) {
    return mod.startsWith("pml");
  }

  public isWW2Mod(mod: string) {
    return mod.startsWith("ww2");
  }

  private checkInfo(valueRef: number, map: string, arg: string, desc = false) {
    // @ts-ignore
    if (!desc && valueRef > this.player[arg].value || desc && valueRef < this.player[arg].value) {
      // @ts-ignore
      this.player[arg].value = valueRef;
      // @ts-ignore
      this.player[arg].mapRef = map;
    }
  }
}
